import { z } from 'zod';

export const ProfileFieldSchema = z.object({
  nickname: z.string().nullable(),
  bio: z.string().nullable(),
  avatarUploadKey: z.string().nullable(),
  coverImageUploadKey: z.string().nullable(),
  spotifyUrl: z.string().nullable(),
  delegateWallet: z.string().nullable(),
  invitedByUserId: z.string().nullable(),
});

export const ProfileErrorSchema = z.object({
  nickname: z.string().nullable(),
  bio: z.string().nullable(),
  avatarUploadKey: z.string().nullable(),
  coverImageUploadKey: z.string().nullable(),
  spotifyUrl: z.string().nullable(),
  delegateWallet: z.string().nullable(),
});

export const ProfileLoadingSchema = z.object({
  avatarUploadKey: z.boolean().nullable(),
  coverImageUploadKey: z.boolean().nullable(),
});

export const ProfilesSchema = z.object({
  fields: ProfileFieldSchema,
  errors: ProfileErrorSchema,
  loading: ProfileLoadingSchema,
});

export type ProfileFormState = z.infer<typeof ProfilesSchema>;
export type ProfileFormFields = ProfileFormState['fields'];
export type ProfileFormErrors = ProfileFormState['errors'];
export type ProfileFormLoading = ProfileFormState['loading'];
